import { Pipe, PipeTransform } from '@angular/core';
import { WorkspaceStatus } from '@workspaces/models/agent';

@Pipe({
  name: 'agentStatus',
  pure: true,
  standalone: true
})
export class AgentStatusPipe implements PipeTransform {
  transform(status: WorkspaceStatus['status'] | string | null | undefined): string {
    if (!status) {
      return 'Status Unavailable';
    }

    const normalizedStatus = status.toUpperCase();

    switch (normalizedStatus) {
      case 'NOT_STARTED':
        return 'Not started';
      case 'IN_PROGRESS':
        return 'In Progress';
      case 'COMPLETED':
        return 'Completed';
      case 'FAILED':
        return 'Failed';
      case 'STATUS_NOT_FOUND':
        return 'Unknown';
      default:
        return this.capitalizeWords(status.replace(/_/g, ' '));
    }
  }

  private capitalizeWords(text: string): string {
    return text
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
}
